module.exports = __webpack_public_path__ + "static/img/linongdsd.a014de7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img2/linongdsd.png
// module id = NGBf
// module chunks = 3